import { Link } from "@remix-run/react";

export default function Footer() {
  return (
    <footer className="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-6 sm:px-8 lg:px-12">
      <p className="text-xs">
        <span dangerouslySetInnerHTML={{ __html: "&copy;" }} /> 2026 Square Zero
        Labs LLC. All rights reserved.
      </p>
      <nav className="sm:ml-auto flex gap-4 sm:gap-6">
        <Link
          to="/terms"
          className="text-xs hover:underline underline-offset-4"
        >
          Terms of Service
        </Link>
        <Link
          to="/privacy"
          className="text-xs hover:underline underline-offset-4"
        >
          Privacy Policy
        </Link>
      </nav>
    </footer>
  );
}
